import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { defaultKcProps, getKcContext, KcApp } from 'keycloakify'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './config/keycloak'

const { kcContext } = getKcContext()

ReactDOM.render(
  <React.StrictMode>
    {kcContext !== undefined ? (
      <KcApp kcContext={kcContext} {...{ ...defaultKcProps }} />
    ) : (
      <ReactKeycloakProvider authClient={keycloak}>
        <App />
      </ReactKeycloakProvider>
    )}
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
